module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTU0OS42IDkxLjNsMzUwLjggMjU0LjlhNjQgNjQgMCAwIDEgMjMuMyA3MS42bC0xMzQgNDEyLjRhNjQgNjQgMCAwIDEtNjAuOSA0NC4ySDI5NS4yYTY0IDY0IDAgMCAxLTYwLjktNDQuMkwxMDAuMyA0MTcuOGE2NCA2NCAwIDAgMSAyMy4zLTcxLjZsMzUwLjgtMjU0LjlhNjQgNjQgMCAwIDEgNzUuMyAweiIgZmlsbD0iIzAiIHAtaWQ9IjM5MjAiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Polygon-filled.svg
// module id = Kecy
// module chunks = 73